import swal from 'sweetalert';

var AlertsMixin = {
    methods: {
        successAlert(title, text) {
            swal({
                icon: 'success',
                title: title,
                text: text,
                buttons: false,
                timer: 3000,
            });
        },
    },
}

export default AlertsMixin;
